// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutUs_wrapper__mfDbX","socialContainer":"AboutUs_socialContainer__543x2","icon":"AboutUs_icon__6m1AK","infoContainer":"AboutUs_infoContainer__Z7HWR"};